import { AutoForm } from "components/Form/AutoForm"
import { Wrapper } from "components/Wrapper"
import { Page } from "components/Page"
import { useRouter } from "components/Router"
import { ErrorsList } from "components/ErrorsList"
import { Button } from "components/Button"
import { useTranslator } from "components/Translator"
import { useBreakpoints } from "hooks/useBreakpoints"
import cx from "classnames"
import { Publicity, PublicityConfigProvider } from "components/Publicity"

export function UserSecurityLoginPage({ csrfToken, error, lastUsername }) {
  const { md } = useBreakpoints()
  const router = useRouter()
  const translator = useTranslator()

  const schema = makeFormSchema(
    router.generate("app_user_security_login"),
    translator,
  )

  return (
    <PublicityConfigProvider>
      <Page padded>
        <Wrapper>
          <div className={"flex lg:px-10 lg:gap-32 xl:gap-64"}>
            <div className="grow shrink-0 space-y-6 lg:space-y-8">
              {error ? <ErrorsList errors={error} /> : null}

              <AutoForm
                schema={schema}
                initialValue={{
                  username: lastUsername,
                  _csrf_token: csrfToken,
                }}
                components={{ SubmitButtonWrapper }}
              />

              <div
                className={cx(
                  {
                    "flex-row space-x-4": md,
                    "flex-col space-y-4": !md,
                  },
                  "flex",
                  "justify-center",
                  "items-center",
                  "text-center",
                )}
              >
                <Button
                  variant="outline"
                  color="secondary"
                  href={router.generate("app_user_security_forgotten")}
                >
                  {translator.trans(
                    "user.security.login.forgottenPassword",
                    null,
                    "pages",
                  )}
                </Button>

                <Button
                  variant="text"
                  color="secondary"
                  className="text-primary-dark"
                  href={router.generate("app_user_security_register")}
                >
                  {translator.trans(
                    "user.security.login.createAccount",
                    null,
                    "pages",
                  )}
                </Button>
              </div>
            </div>

            <div className={"shrink-0 hidden lg:block"}>
              <Publicity name={"login"} />
            </div>
          </div>
        </Wrapper>
      </Page>
    </PublicityConfigProvider>
  )
}

const makeFormSchema = (action, translator) => {
  return {
    $id: "???",
    $schema: "https://json-schema.org/draft/2020-12/schema",
    options: {
      form: {
        action,
        async: false,
        method: "POST",
      },
      layout: "default",
      widget: "user_login",
    },
    title: "",
    type: "object",
    required: [],
    properties: {
      _csrf_token: {
        type: "string",
        title: "",
        options: {
          layout: "default",
          widget: "hidden",
        },
      },
      username: {
        type: "string",
        title: translator.trans("user.security.login.username", null, "pages"),
        options: {
          layout: "default",
          widget: "text",
        },
      },
      password: {
        type: "string",
        title: translator.trans("user.security.login.password", null, "pages"),
        options: {
          layout: "default",
          widget: "password",
        },
      },
      _remember_me: {
        type: "boolean",
        title: translator.trans(
          "user.security.login.rememberMe",
          null,
          "pages",
        ),
        options: {
          layout: "default",
          widget: "checkbox",
        },
      },
    },
  }
}

const SubmitButtonWrapper = ({ children }) => {
  return <div className={"flex flex-col"}>{children}</div>
}
